// config.ts
import logger from "./logger";

logger.info('Environment variables:', {
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_LOG_LEVEL: process.env.REACT_APP_LOG_LEVEL,
  REACT_APP_STAGE: process.env.REACT_APP_STAGE,
  REACT_APP_DOMAIN: process.env.REACT_APP_DOMAIN,
  REACT_APP_IS_PRODUCTION: process.env.REACT_APP_IS_PRODUCTION
});

const ENV = process.env.REACT_APP_ENV || "main";
const STAGE = process.env.REACT_APP_STAGE || "production";
const DOMAIN = process.env.REACT_APP_DOMAIN || "mycatch.co.uk";
logger.info('Selected ENV value:', ENV);
logger.info('Selected STAGE value:', STAGE);
logger.info('Using domain:', DOMAIN);

const SITE_NAME = "mycatch";

// Base URLs for different environments
const getApiUrls = () => {
  const isProduction = process.env.REACT_APP_IS_PRODUCTION === 'true';
  
  if (isProduction) {
    logger.info('Using production URLs');
    return {
      public: `https://api.public.${DOMAIN}`,
      private: `https://api.private.${DOMAIN}`
    };
  } else {
    // For non-production environments, use environment-specific URLs
    logger.info('Using environment-specific URLs for:', STAGE);
    return {
      public: `https://api.public.${ENV}.${DOMAIN}`,
      private: `https://api.private.${ENV}.${DOMAIN}`
    };
  }
};

const { public: PUBLIC_API_URL, private: PRIVATE_API_URL } = getApiUrls();
logger.info('Final API URLs:', { PUBLIC_API_URL, PRIVATE_API_URL });

const MAPS_KEY = process.env.REACT_APP_MAPS_KEY || "AIzaSyAKlkQVTixwu2PMXgGTVYbWq6be8yGrvtY";
const CAPATCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY || "6LdlTnYqAAAAAE0YuE1triTlKgpprf4qs9Q975-4";
const LOG_LEVEL = process.env.REACT_APP_LOG_LEVEL || "1";

// Maintenance mode configuration
export const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
export const MAINTENANCE_MESSAGE = process.env.REACT_APP_MAINTENANCE_MESSAGE || 'The site is currently down for maintenance';

export default PUBLIC_API_URL;
export { MAPS_KEY, STAGE, SITE_NAME, CAPATCHA_KEY, PUBLIC_API_URL, PRIVATE_API_URL, DOMAIN, LOG_LEVEL };
